import { MutationTree } from 'vuex';
import { SuccessToasterState } from './state';
import { SUCCESS } from '@/modules/SuccessToaster/store/mutation-types';

export const mutations: MutationTree<SuccessToasterState> = {
    [SUCCESS.SET_ACTIVE](state: SuccessToasterState, isActive: boolean) :void {
        state.activeToast = isActive;
    },
};
